import React from 'react';

export const CustomerDetailLeftSkeleton = () => (
    <>
        <div className="mb-4 text-center">
            <div className="wd-150 ht-150 mx-auto mb-3 rounded-circle" style={{ backgroundColor: '#f2f4f7' }}></div>
            <div className="mb-4">
                <div className="table-skeleton mx-auto mb-2" style={{ width: '55%' }}></div>
                <div className="table-skeleton mx-auto" style={{ width: '70%' }}></div>
            </div>
            <div className="fs-12 fw-normal text-muted text-center d-flex flex-wrap gap-3 mb-4">
                <div className="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                    <div className="table-skeleton mx-auto mb-2" style={{ width: '70%' }}></div>
                    <div className="table-skeleton mx-auto" style={{ width: '50%' }}></div>
                </div>
                <div className="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                    <div className="table-skeleton mx-auto mb-2" style={{ width: '70%' }}></div>
                    <div className="table-skeleton mx-auto" style={{ width: '50%' }}></div>
                </div>
                <div className="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                    <div className="table-skeleton mx-auto mb-2" style={{ width: '70%' }}></div>
                    <div className="table-skeleton mx-auto" style={{ width: '50%' }}></div>
                </div>
            </div>
        </div>

        <ul className="list-unstyled mb-4">
            <li className="hstack justify-content-between mb-4">
                <div className="table-skeleton" style={{ width: '40%' }}></div>
                <div className="table-skeleton" style={{ width: '35%' }}></div>
            </li>
            <li className="hstack justify-content-between mb-4">
                <div className="table-skeleton" style={{ width: '40%' }}></div>
                <div className="table-skeleton" style={{ width: '35%' }}></div>
            </li>
            <li className="hstack justify-content-between mb-0">
                <div className="table-skeleton" style={{ width: '40%' }}></div>
                <div className="table-skeleton" style={{ width: '35%' }}></div>
            </li>
        </ul>

        <div className="d-flex gap-2 text-center pt-4">
            <div className="w-50 table-skeleton" style={{ height: '38px', borderRadius: '8px' }}></div>
            <div className="w-50 table-skeleton" style={{ height: '38px', borderRadius: '8px' }}></div>
        </div>
    </>
);

export const CustomerDetailRightSkeleton = () => (
    <>
        <div className="about-section mb-5">
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <div className="table-skeleton" style={{ width: '180px' }}></div>
                <div className="table-skeleton" style={{ width: '90px', height: '30px', borderRadius: '8px' }}></div>
            </div>
            <div className="table-skeleton mb-3" style={{ width: '100%' }}></div>
            <div className="table-skeleton mb-3" style={{ width: '92%' }}></div>
            <div className="table-skeleton" style={{ width: '85%' }}></div>
        </div>

        <div className="profile-details mb-5">
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <div className="table-skeleton" style={{ width: '180px' }}></div>
                <div className="table-skeleton" style={{ width: '110px', height: '30px', borderRadius: '8px' }}></div>
            </div>
            {Array.from({ length: 6 }, (_, index) => index).map((item) => (
                <div className="row g-0 mb-4" key={`detail-skeleton-${item}`}>
                    <div className="col-sm-6"><div className="table-skeleton" style={{ width: '70%' }}></div></div>
                    <div className="col-sm-6"><div className="table-skeleton" style={{ width: '80%' }}></div></div>
                </div>
            ))}
        </div>
    </>
);
